import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Badge, OverlayTrigger, Popover } from 'react-bootstrap';
import { isObject } from 'lodash';
import { useProductListingState } from '../RangePlanProductListingProvider';
import noImage from '../../../../assets/images/no-image.png';
import { shortenandHoverString } from '../../../../Components/helper';
import CommonImageComponent from '../../../../Components/Utility/CommonImage';
import Loader from '../../../../Components/Utility/Loader/Loader';

export default function ProductCareLabel(props) {
  const { handlePageNextInScroll, loadNextData, handleSelection, selectedIds, isSelectAll } = props;
  const { t } = useTranslation('common');

  const {
    rangePlanProvider: { productsNumber, productsList },
  } = useProductListingState();
  const [expandedRowIndex, setExpandedRowIndex] = useState([]);
  const [isExpandAll, setIsExpandAll] = useState(false);

  useEffect(() => {
    if (isExpandAll && productsList?.length > 0) {
      setExpandedRowIndex(productsList.map((_, index) => index));
    }
  }, [productsList?.length]);

  const getValue = (value) => {
    if (isObject(value)) {
      return value?.name || '';
    }
    return value || '--';
  };

  const expandMoreData = (index) => {
    if (expandedRowIndex.includes(index)) {
      setIsExpandAll(false);
      setExpandedRowIndex(expandedRowIndex.filter((item) => item !== index));
    } else {
      setExpandedRowIndex([...expandedRowIndex, index]);
    }
  };

  const expandAllProdIdentifier = () => {
    if (isExpandAll) {
      setIsExpandAll(false);
      setExpandedRowIndex([]);
    } else {
      setIsExpandAll(true);
      setExpandedRowIndex(productsList?.map((_, index) => index) || []);
    }
  };
  return (
    <div id="ProductIdentifierRPTableContainer" className="rp-scroll-container">
      <InfiniteScroll
        dataLength={productsList?.length}
        hasMore={productsList?.length < productsNumber}
        next={handlePageNextInScroll}
        loader={loadNextData && <Loader />}
        className="fixed-col-container rp-table-container"
        scrollableTarget="ProductIdentifierRPTableContainer"
      >
        <table id="RPProductCareLabelTable" className="table common-custom-table fixed-header mb-0">
          <thead>
            <tr>
              <th className="w-50px">
                <div className="common-checkbox margin-auto">
                  <input
                    type="checkbox"
                    onChange={(e) => handleSelection(e.target.checked)}
                    name="check_all_product_care_label"
                    id="check_all_product_care_label"
                    checked={isSelectAll}
                    disabled={!productsList?.length}
                  />
                  <label htmlFor="check_all_product_care_label" className="chklabel" />
                </div>
              </th>
              <th className="w-50px">
                <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandAllProdIdentifier()}>
                  {isExpandAll ? <span className="icon-new-down-arrow-icon icon-inverse" /> : <span className="icon-new-down-arrow-icon " />}
                </button>
              </th>
              <th className="w-80px">{t('RANGE_PLANS.PRODUCT_LIST.IMAGE')}</th>
              <th className="w-220px">{t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_NUMBER')}</th>
              <th className="w-200px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_CARE_LABEL.TYPE')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_CARE_LABEL.CODE')}</th>
              <th className="w-300px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_CARE_LABEL.DESCRIPTION')}</th>
              <th className="w-224px">{t('RANGE_PLANS.PRODUCT_LIST.EXPAND_VIEW_MODULES.PRODUCT_INFO_CARE_LABEL.CARE_SUB_TYPE')}</th>
            </tr>
          </thead>

          {productsList?.length > 0 ? (
            productsList?.map((ele, productIndex) => {
              const initialData = ele?.initialData;
              const productImage = ele?.image || noImage;
              return (
                <tbody key={ele?._id}>
                  <tr>
                    <td>
                      <div className="common-checkbox margin-auto">
                        <input
                          onChange={() => {
                            handleSelection(ele?._id);
                          }}
                          name={`checks_${productIndex}`}
                          id={`checks_${productIndex}`}
                          type="checkbox"
                          checked={selectedIds?.filter((val) => val === ele?._id)?.length > 0}
                        />
                        <label htmlFor={`checks_${productIndex}`} className="chklabel" />
                      </div>
                    </td>
                    <td>
                      {ele?.expandData?.length > 0 && (
                        <button type="button" className="btn-up-down" aria-label={t('COMMON_LABEL.COLLAPSE')} onClick={() => expandMoreData(productIndex)}>
                          {expandedRowIndex.includes(productIndex) ? (
                            <span className="icon-new-down-arrow-icon icon-inverse" />
                          ) : (
                            <span className="icon-new-down-arrow-icon" />
                          )}
                        </button>
                      )}
                    </td>
                    <td>
                      <CommonImageComponent productImage={productImage} />
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        {ele?.number}
                        <button type="button" className="btn ml-auto" aria-label="info">
                          <OverlayTrigger
                            placement={t('TAKING_DATES.BUTTON')}
                            trigger="hover"
                            rootClose
                            overlay={
                              <Popover className="custom-popover">
                                <Popover.Content>
                                  <p className="mb-8">
                                    <b className="text-bold">Product Type: </b>
                                    {getValue(ele?.supplierType)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Description: </b>
                                    {getValue(ele?.description)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Brand: </b>
                                    {getValue(ele?.brandId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Season: </b>
                                    {getValue(ele?.seasonId)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Month: </b>
                                    {getValue(ele?.month)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Year: </b>
                                    {getValue(ele?.year)}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Colourway(s): </b>

                                    {ele?.colourLibraries?.map((gradEle) => gradEle?.name)?.join(', ') || '--'}
                                  </p>
                                  <p className="mb-8">
                                    <b className="text-bold">Size: </b>
                                    {ele?.sizeRanges?.join(', ') || '--'}
                                  </p>
                                </Popover.Content>
                              </Popover>
                            }
                          >
                            <span className="icon icon-Information f-20" />
                          </OverlayTrigger>
                        </button>
                      </div>
                    </td>
                    <td className="first-fix-col">
                      <div className="d-flex align-items-center">
                        {shortenandHoverString(initialData?.type || '--', 20)}
                        {initialData?.type && (
                          <Link target="_blank" to={`/development-order/${ele?._id}/care-user-instruction`} className="px-3 ml-auto text-decoration-none">
                            <span className="icon-redirect f-20" />
                          </Link>
                        )}
                        <div style={{ width: 20 }}>
                          {ele?.expandData?.length >= 1 && <Badge className="range-badge badge badge-rp-counter">{(ele?.expandData?.length || 0) + 1}</Badge>}
                        </div>
                      </div>
                    </td>
                    <td>{shortenandHoverString(initialData?.Code || '--', 40)}</td>
                    <td>{shortenandHoverString(initialData?.Description || '--', 80)}</td>
                    <td>{shortenandHoverString(initialData?.['Care Type']?.name || initialData?.['Disclaimer Type']?.name || '--', 40)}</td>
                  </tr>
                  {expandedRowIndex.includes(productIndex) &&
                    ele?.expandData?.map((expData) => {
                      return (
                        <tr className="expand-row" key={expData?._id}>
                          <td />
                          <td />
                          <td />
                          <td />
                          <td>{shortenandHoverString(expData?.type || '--', 20)}</td>
                          <td>{shortenandHoverString(expData?.Code || '--', 40)}</td>
                          <td>{shortenandHoverString(expData?.Description || '--', 80)}</td>
                          <td>{shortenandHoverString(expData?.['Care Type']?.name || expData?.['Disclaimer Type']?.name || '--', 40)}</td>
                        </tr>
                      );
                    })}
                </tbody>
              );
            })
          ) : (
            <tr>
              <td colSpan={8} className="text-center">
                {t('RANGE_PLANS.PRODUCT_LIST.NO_RECORDS_FOUND')}
              </td>
            </tr>
          )}
        </table>
      </InfiniteScroll>
    </div>
  );
}